module.exports = __webpack_public_path__ + "static/media/phone-call.0d42544c.svg";